import { render } from "./SimpleMarkdown.vue?vue&type=template&id=73ac2342&scoped=true"
import script from "./SimpleMarkdown.vue?vue&type=script&lang=js"
export * from "./SimpleMarkdown.vue?vue&type=script&lang=js"

import "./SimpleMarkdown.vue?vue&type=style&index=0&id=73ac2342&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ac2342"]])

export default __exports__